import React, { useState, useEffect, useRef } from 'react';
import authService from 'services/authService';
import Swal from 'sweetalert2';
import 'styles/manager.css';

export const UsersView = () => {
  const [users, setUsers] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  // Solo la primera carga muestra el spinner de pantalla completa
  const [initialLoad, setInitialLoad] = useState(true);
  // Evita que una respuesta vieja sobrescriba una más reciente
  const requestIdRef = useRef(0);

  const toast = (icon, title) =>
    Swal.fire({ toast: true, position: 'top-end', icon, title, showConfirmButton: false, timer: 2000 });
  const [currentPage, setCurrentPage] = useState(1);
const [pagination, setPagination] = useState({
  page: 1,
  limit: 5,
  totalCount: 0,
  totalPages: 1,
  hasNext: false,
  hasPrev: false, 
});

// Carga inicial + búsqueda con debounce (sin búsqueda carga inmediato)
useEffect(() => {
  const delay = setTimeout(() => {
    loadUsers(1);
  }, searchTerm ? 400 : 0);
  return () => clearTimeout(delay);
}, [searchTerm]);

const loadUsers = async (page = currentPage) => {
  const requestId = ++requestIdRef.current;
  try {
    setLoading(true);

    const response = await authService.getUsers({
      page,
      limit: pagination.limit,
      search: searchTerm,
    });

    if (requestId !== requestIdRef.current) return; // respuesta vieja
    if (!response.error) {
      setUsers(response.data.data || []);
      setPagination(response.data.pagination);
      setCurrentPage(response.data.pagination.page);
    }
  } catch (error) {
    Swal.fire('Error', 'No se pudieron cargar los usuarios', 'error');
  } finally {
    if (requestId === requestIdRef.current) {
      setLoading(false);
      setInitialLoad(false);
    }
  }
};

const handlePageChange = (newPage) => {
  if (newPage < 1 || newPage > pagination.totalPages) return;
  loadUsers(newPage);
};
  // Reset password
  const handleResetPassword = async (user) => {
    const result = await Swal.fire({
      title: '¿Resetear contraseña?',
      text: `Usuario: ${user.nombre}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, resetear',
    });

    if (!result.isConfirmed) return;

    try {
      const res = await authService.resetUserPassword(user.id);

      if (!res.error) {
        const newPassword = res.data?.data?.newPassword;

        Swal.fire({
          icon: 'success',
          title: 'Contraseña reseteada',
          showConfirmButton: false,
          html: newPassword
            ? `<b>Nueva contraseña:</b><br>${newPassword}`
            : 'Se envió al correo',
        });
      }
    } catch {
      Swal.fire('Error', 'No se pudo resetear', 'error');
    }
  };

  // Activar / desactivar
  const handleToggle = async (user) => {
  const newStatus = !user.activo;

  const result = await Swal.fire({
    title: `${newStatus ? 'Activar' : 'Desactivar'} usuario`,
    text: user.nombre,
    showCancelButton: true,
    confirmButtonText: 'Confirmar',
  });

  if (!result.isConfirmed) return;

  try {
    const res = await authService.updateUser(user.id, {
      activo: newStatus
    });

if (!res.error) {
  toast('success', 'Estado actualizado');
  loadUsers();
}} catch {
  toast('error', 'No se pudo actualizar');
}
};

  // Crear admin
  const handleCreateAdmin = async () => {
    const result = await Swal.fire({
      title: 'Nuevo Administrador',
      html: `
        <input id="nombre" class="swal2-input" placeholder="Nombre">
        <input id="email" class="swal2-input" placeholder="Email">
        <input id="password" type="password" class="swal2-input" placeholder="Password">
      `,
      showCancelButton: true,
      confirmButtonText: 'Crear',
      preConfirm: () => {
        const nombre = document.getElementById('nombre').value;
        const email = document.getElementById('email').value;
        const password = document.getElementById('password').value;

        if (!nombre || !email || !password) {
          Swal.showValidationMessage('Todos los campos son obligatorios');
          return false;
        }

        return { nombre, email, password };
      },
    });

    if (!result.isConfirmed) return;

    try {
      const res = await authService.registerAdmin(result.value);

      if (!res.error) {
        toast('success', 'Administrador creado');
        loadUsers();
      }
    } catch {
      toast('error', 'No se pudo crear');
    }
  };

  const handleEditUser = async (user) => {
  const result = await Swal.fire({
    title: 'Editar Usuario',
    html: `
      <input id="nombre" class="swal2-input" value="${user.nombre}" placeholder="Nombre">
      <input id="email" class="swal2-input" value="${user.email}" placeholder="Email">
    `,
    showCancelButton: true,
    confirmButtonText: 'Guardar',
    preConfirm: () => {
      const nombre = document.getElementById('nombre').value;
      const email = document.getElementById('email').value;

      if (!nombre || !email) {
        Swal.showValidationMessage('Campos obligatorios');
        return false;
      }

      return { nombre, email };
    }
  });

  if (!result.isConfirmed) return;

  try {
    const res = await authService.updateUser(user.id, result.value);

    if (!res.error) {
     toast('success','Usuario actualizado');
      loadUsers();
    }
  } catch {
    toast( 'error', 'No se pudo actualizar',);
  }
};

const renderPageNumbers = () => {
  const pages = [];
  const { totalPages } = pagination;

  let start = Math.max(1, currentPage - 2);
  let end = Math.min(totalPages, start + 4);

  if (end - start < 4) start = Math.max(1, end - 4);

  for (let i = start; i <= end; i++) {
    pages.push(
      <button
        key={i}
        className={`pagination-btn ${i === currentPage ? 'pagination-btn--active' : ''}`}
        onClick={() => handlePageChange(i)}
      >
        {i}
      </button>
    );
  }

  return pages;
};

  if (initialLoad) {
    return <div className="loading-state"><div className="spinner"></div></div>;
  }

  return (
    <div className="providers-view">
      <div className="card">
        <div className="card-header">Gestión de Usuarios</div>

        <div className="providers-actions">
          <input
            className="search-box"
            placeholder="Buscar usuarios..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <button className="btn btn-primary" onClick={handleCreateAdmin}>
            + Admin
          </button>
        </div>

        <div className="providers-list" style={{ opacity: loading ? 0.5 : 1, pointerEvents: loading ? 'none' : 'auto', transition: 'opacity 0.2s' }}>
          {users.length === 0 ? (
            <div className="empty-state">Sin usuarios</div>
          ) : (
            users.map((user) => (
              <div key={user.id} className="provider-card">

                <div className="provider-info">
                  <h3 className="provider-name">{user.nombre}</h3>

                  <div className="provider-details-grid">
                    <div>
                      <div className="detail-label">Email</div>
                      <div>{user.email}</div>
                    </div>

                    <div>
                      <div className="detail-label">Rol</div>
                      <div>{user.rol}</div>
                    </div>

                    <div>
                      <div className="detail-label">Estado</div>
                      <span
                        className={`status-badge ${user.activo ? 'status-aprobada' : 'status-rechazada'}`}
                        onClick={() => handleToggle(user)}
                        style={{ cursor: 'pointer' }}
                      >
                        {user.activo ? 'Activo' : 'Inactivo'}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="provider-actions d-flex gap-2">
                   <button
    className="btn btn-edit"
    onClick={() => handleEditUser(user)}
  >
    <i className="bi bi-pencil"></i>
  </button>
                  {/* Reset */}
                  <button
                    className="btn btn-warning"
                    onClick={() => handleResetPassword(user)}
                  >
                    <i className="bi bi-key"></i>
                  </button>

                </div>

              </div>
            ))
          )}
        </div>

        {pagination.totalPages > 1 && (
  <div className="pagination">
    <div className="pagination-info">
      Mostrando {users.length} de {pagination.totalCount} usuarios
    </div>

    <div className="pagination-controls">
      <button
        className="pagination-btn"
        onClick={() => handlePageChange(1)}
        disabled={!pagination.hasPrev}
      >
        «
      </button>

      <button
        className="pagination-btn"
        onClick={() => handlePageChange(currentPage - 1)}
        disabled={!pagination.hasPrev}
      >
        ‹
      </button>

      {renderPageNumbers()}

      <button
        className="pagination-btn"
        onClick={() => handlePageChange(currentPage + 1)}
        disabled={!pagination.hasNext}
      >
        ›
      </button>

      <button
        className="pagination-btn"
        onClick={() => handlePageChange(pagination.totalPages)}
        disabled={!pagination.hasNext}
      >
        »
      </button>
    </div>
  </div>
)}
      </div>
    </div>
  );
};